import { Box, Paper, Text, UnstyledButton, useComputedColorScheme } from "@mantine/core";
import { VisualAcuityNotation } from "@utils/test-specific-utils/VisualAcuityUtils";

interface VisualAcuityNotationSelectorProps {
  value: VisualAcuityNotation;
  onChange: (value: VisualAcuityNotation) => void;
}

const notationOptions = [
  { label: "Decimal", value: VisualAcuityNotation.SnellenDecimal },
  { label: "Meter", value: VisualAcuityNotation.SnellenMeter },
  { label: "logMAR", value: VisualAcuityNotation.Logmar },
];

export default function VisualAcuityNotationSelector(props: VisualAcuityNotationSelectorProps) {
  const isDark = useComputedColorScheme("light") === "dark";

  return (
    <Box w={280} maw="100%" role="radiogroup" aria-label="Visual acuity notation">
      <Paper
        p={4}
        radius="md"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${notationOptions.length}, minmax(0, 1fr))`,
          gap: 4,
          backgroundColor: isDark ? "var(--mantine-color-dark-6)" : "var(--mantine-color-gray-1)",
        }}
      >
        {notationOptions.map((option) => {
          const isSelected = option.value === props.value;

          return (
            <UnstyledButton
              key={option.value}
              onClick={() => props.onChange(option.value)}
              role="radio"
              aria-checked={isSelected}
              aria-label={option.label}
              style={{
                minWidth: 0,
                borderRadius: 8,
                padding: "5px 6px",
                backgroundColor: isSelected
                  ? isDark
                    ? "var(--mantine-color-dark-4)"
                    : "white"
                  : "transparent",
                boxShadow: isSelected ? "0 1px 3px rgba(0, 0, 0, 0.12)" : "none",
              }}
            >
              <Text
                ta="center"
                size="sm"
                fw={500}
                c={isSelected ? (isDark ? "white" : "gray.8") : isDark ? "dark.1" : "gray.7"}
                style={{ whiteSpace: "nowrap" }}
              >
                {option.label}
              </Text>
            </UnstyledButton>
          );
        })}
      </Paper>
    </Box>
  );
}
